module.exports = __webpack_public_path__ + "media/images/no_image_yebisu-2a15da963a74f446450010e5917c9f95.jpg";